import DateFormatter from "shared/formatters/dates";

// Use this renderer when diplaying columns using timestamps
export default function timestamp(node, config) {
  var val = this.model.get(config.attr);

  if (!val) {
    node.html("&mdash;");
  } else {
    node.text(DateFormatter.fromDB(val));
  }
}
